import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("出库通知单号"),
    dataIndex: "delivery_order_number",
    fixed: "left",
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "number" },
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("复核数量"),
    dataIndex: "total_quantity",
    width: 100,
    ellipsis: true,
  },
  {
    title: T("复核重量(吨)"),
    dataIndex: "total_weight",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("复核面积(平方米)"),
    dataIndex: "total_area",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("复核体积(立方米)"),
    dataIndex: "total_volume",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("仓库"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("规格"),
    dataIndex: "material_spec",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("序列号"),
    dataIndex: "serial_number",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("箱号"),
    dataIndex: "packing_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("订单类型"),
    dataIndex: "order_type_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("往来单位单号"),
    dataIndex: "external_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("预计到货日期"),
    dataIndex: "arrival_date",
    width: 160,
    ellipsis: true,
  },
  {
    title: T("收货人"),
    dataIndex: "customer_contact",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("收货地址"),
    dataIndex: "receiving_address",
    width: 240,
    ellipsis: true,
  },
];
